import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import UrsHeader from "../components/UrsHeader";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { input, news, sip } from "../translate";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownWideShort, faArrowUpShortWide, faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import TableBody from "@mui/material/TableBody";
import TableLoader from "../components/TableLoader";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Link, useLocation, useNavigate } from "react-router-dom";
import qs from "query-string";
import AddAndEditNews from "../components/AddAndEditNews";
import Api from "../Api";
import { useSelector } from "react-redux";
import NewsGraffic from '../components/NewsGraffic';
const { REACT_APP_SERVER } = process.env;
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

function UrsNews(props) {
    const [create, setCreate] = useState(false)
    const [edit, setEdit] = useState(false)
    const [newsList, setNewsList] = useState([])
    const [loading, setLoading] = useState(false)
    const [side, setSide] = useState("news")

    const location = useLocation()
    const navigate = useNavigate()
    const profile = useSelector(state => state.users.ursData)

    const query = qs.parse(location.search, { arrayFormat: 'comma' });
    useEffect(() => {
        (async () => {
            setLoading(true)
            const { data } = await Api.getNewsList();
            setNewsList(data.list)
            setLoading(false)
        })()
    }, [])

    useEffect(() => {
        if (profile.admingroup) {
            if (profile.admingroup !== 1) {
                navigate('/not-found')
            }
        }

    }, [profile])

    const handleDelete = async (id) => {
        setLoading(true)
        const { data } = await Api.deleteNewsSingle(id)
        setNewsList(data.list)
        setLoading(false)
    }
    return (
        <>

            <Helmet>
                <title>Admin Panel</title>
            </Helmet>
            <UrsHeader />
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20, }}>
                <div className="tableParent" id="tableParent">
                    <Paper
                        style={{ width: window.innerWidth <= 1024 ? '100%' : 1024, }}
                        sx={{ minWidth: 'fit-content', fontSize: 10, width: window.innerWidth <= 1024 ? '100%' : 1024, }}>
                        {side === "graff" ?
                            <NewsGraffic setSide={setSide} newsData={newsList}/>
                            : <TableContainer
                            >
                                <Table className={loading ? "myTableStyle" : ''} stickyHeader
                                    aria-label="sticky table">
                                    <TableHead>
                                        <TableRow className="sip_header">
                                            <TableCell sx={{ fontSize: 20, }} align="left" colSpan={2}>
                                                <div style={{ cursor: "pointer" }} className="d-flex align-items-center">
                                                    <span onClick={() => setSide("news")}>{news.news[+localStorage.getItem('atsLang') || 1]}</span>
                                                    <div className="header_border" style={{ height: 30,  backgroundPosition: 'center' }} />
                                                    <span onClick={() => setSide("graff")}>Գրաֆիկ</span>
                                                </div>

                                            </TableCell>
                                            <TableCell sx={{ fontSize: 15, padding: '0 35px', height: 50 }} align="right"
                                            >
                                                <span className="d-flex justify-content-end align-items-center">

                                                </span>
                                                <span className="add" onClick={() => setCreate(true)}>
                                                    <AddCircleOutlineIcon />
                                                </span>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow className="sip_num">
                                            <TableCell
                                                className="action"
                                                align='center'
                                            >
                                                Ստատուս
                                            </TableCell>
                                            <TableCell
                                                className="action"
                                                align='center'
                                            >
                                                Անուն
                                            </TableCell> <TableCell
                                                className="action"
                                                align='center'
                                            >
                                                {sip.action[+localStorage.getItem('atsLang') || 1]}
                                            </TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody id="dataBody">

                                        {loading ? <TableLoader colSpan={3} /> : newsList.length ? newsList.map((s, _) => (
                                            <TableRow key={_} hover role="checkbox" tabIndex={-1}>

                                                <TableCell className="action" align="center">
                                                    {s.status ? <CheckCircleIcon style={{ fontSize: 18, color: color, marginLeft: 10 }} /> : null}
                                                </TableCell>
                                                <TableCell className="action" align="center">
                                                    {s.title_hy}
                                                </TableCell>
                                                <TableCell className="action" align="center">
                                                    <p style={{
                                                        fontSize: 13,
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent: 'center'
                                                    }}> <span onClick={() => {
                                                        setEdit(s.id)
                                                    }} className="edit"><FontAwesomeIcon
                                                                icon={faPenToSquare} /></span>

                                                        <span onClick={() => handleDelete(s.id)}
                                                            className="delete"><FontAwesomeIcon
                                                                icon={faTrashCan} /></span>

                                                    </p>
                                                </TableCell>

                                            </TableRow>

                                        )) : <TableRow hover role="checkbox" tabIndex={-1}>


                                            <TableCell align="center" colSpan={3}>
                                                no data

                                            </TableCell>


                                        </TableRow>
                                        }


                                    </TableBody>
                                </Table>
                            </TableContainer>}


                    </Paper>
                </div>
                {create || edit ? <AddAndEditNews setList={setNewsList} open={create || edit} edit={edit} setOpen={edit ? setEdit : setCreate} /> : null}
            </div>
        </>
    );
}

export default UrsNews;